import { FormControlLabel, Switch, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface ToggleProps<T extends FieldValues> {
  label: string;
  controlGroup: Control<T, any>;
  controlName: Path<T>;
}
/**
 * Generic component to display a toggle field
 * @param props Data needed by the form controller to display the toggle field
 * @returns
 */
const ToggleComponent = <T extends FieldValues>(props: ToggleProps<T>) => {
  const { t } = useTranslation();
  const { label, controlGroup, controlName } = props;
  return (
    <>
      <Grid2 xs={1} sx={{ display: 'flex' }}>
        <Typography variant="body1">{t(label)}</Typography>
      </Grid2>
      <Grid2 xs={1}>
        <Controller
          name={controlName}
          control={controlGroup}
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              sx={{ m: 0 }}
              labelPlacement="start"
              control={
                <Switch size="small" checked={!!value} onChange={onChange} />
              }
              label={
                value
                  ? t('hexa_api.fields.active_state')
                  : t('hexa_api.fields.non_active_state')
              }
            />
          )}
        />
      </Grid2>
    </>
  );
};

export default ToggleComponent;
